import { Layout, Lamp as LampComponent } from "components"
export const Lamp = () => {
 return (
  <Layout>
   <LampComponent />
  </Layout>
 )
}
